import Tbm3DidPreconditionsDynamic from '@/features/engineoil/preconditions/common/Tbm3DidPreconditionsDynamic';
import Tbm3DidPreconditionsStatic from '@/features/engineoil/preconditions/common/Tbm3DidPreconditionsStatic';
import type { EngineOil } from '@/generated/GeneratedApiTypes';

const Tbm3DidPreconditions = ({ engineOil }: { engineOil: EngineOil }) =>
    engineOil.preconditions ? <Tbm3DidPreconditionsDynamic engineOil={engineOil} /> : <Tbm3DidPreconditionsStatic />;

export default Tbm3DidPreconditions;
